import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const fetchAllCoupons = createAsyncThunk(
    'coupon/fetchAllCoupons',
    async (_, { rejectWithValue }) => {
        try {
            const response = await callAPIWithoutAuth(
                apiUrls.coupons,
                {},
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch coupons');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

const couponSlice = createSlice({
    name: 'coupon',
    initialState: {
        coupons: [],
        limitLessCoupons: [],
        limitLessLoader: false,
        data: [],
        loading: false,
        error: null,
        pagination: null
    },
    reducers: {
        clearCouponError: (state) => {
            state.error = null;
        },
        clearCoupons: (state) => {
            state.coupons = [];
            state.data = [];
            state.pagination = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllCoupons.pending, (state) => {
                state.limitLessLoader = true;
                state.error = null;
            })
            .addCase(fetchAllCoupons.fulfilled, (state, action) => {
                state.limitLessLoader = false;
                if (action.payload && action.payload.data) {
                    state.limitLessCoupons = action.payload.data;
                } else {
                    state.limitLessCoupons = action.payload;
                }
            })
            .addCase(fetchAllCoupons.rejected, (state, action) => {
                state.limitLessLoader = false;
                state.error = action.payload;
            });
    }
});

export const { clearCouponError, clearCoupons } = couponSlice.actions;
export default couponSlice.reducer;